import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'react-bootstrap';

import withId from '../../decorators/withId';

export class CheckboxInput extends Component {
  static propTypes = {
    /** Input value */
    value: PropTypes.bool,
    /** Label text */
    title: PropTypes.string.isRequired,
    /** Disable input */
    disabled: PropTypes.bool,
    /** Gets called when user changes value in input */
    onChange: PropTypes.func,
    /** Passed to data-id prop on button component
     *  @ignore
     */
    id: PropTypes.string,
    ariaLabel: PropTypes.string,
    name: PropTypes.string,
    /** To be used with title or ariaLabel */
    titleHidden: PropTypes.bool,
    required: PropTypes.bool,
  };

  static defaultProps = {
    value: false,
    disabled: false,
    onChange: () => {},
    id: null,
    ariaLabel: null,
    name: null,
    titleHidden: false,
    required: false,
  };

  constructor(props) {
    super(props);

    this.state = {
      value: props.value,
      previousPropValue: props.value,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { value } = nextProps;
    if (value !== prevState.previousPropValue) {
      return {
        value,
        previousPropValue: value,
      };
    }
    return null;
  }

  handleOnChange = (event) => {
    const { onChange } = this.props;
    const { checked } = event.target;

    this.setState({ value: checked });
    onChange(checked);
  }

  ariaLabel() {
    const {
      ariaLabel,
      title,
      titleHidden,
    } = this.props;

    if (!ariaLabel && titleHidden) {
      return title;
    }

    return ariaLabel;
  }

  render() {
    const {
      id,
      title,
      disabled,
      titleHidden,
      name,
      required,
    } = this.props;

    const { value } = this.state;

    return (
      <Checkbox
        data-id={id}
        checked={value}
        disabled={disabled}
        onChange={this.handleOnChange}
        aria-label={this.ariaLabel()}
        className={titleHidden && 'titleHidden'}
        name={name}
        required={required}
      >
        {!titleHidden && title}
      </Checkbox>
    );
  }
}

export default withId('CheckboxInput')(CheckboxInput);
